import React, { useState, useEffect } from 'react';
import './PaymentMethods.css';

const PaymentMethods = () => {
  const [paymentMethods, setPaymentMethods] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [showViewModal, setShowViewModal] = useState(false);
  const [viewingMethod, setViewingMethod] = useState(null);
  const [editingMethod, setEditingMethod] = useState(null);
  const [showOtpModal, setShowOtpModal] = useState(false);
const [otp, setOtp] = useState('');
const [pendingId, setPendingId] = useState(null);
const [currentAction, setCurrentAction] = useState(null); // 'add' or 'update'
  const [formData, setFormData] = useState({
    wallet_name: '',
    wallet_address: '',
    payment_type: 'Crypto Wallet',
    status: 'active',
    qr_upload: null,
    // bank fields
    bank_account_holder: '',
    bank_payment_method: '',
    bank_iban: '',
    bank_swift: '',
    bank_name: '',
    bank_address: '',
    bank_country: '',
    account_currency: ''
  });

  const API_BASE_URL = 'https://server.account.majestyfx.com';
  const IMAGE_BASE_URL = 'https://server.account.majestyfx.com';

  // Fetch payment methods
  const fetchPaymentMethods = async () => {
    try {
      setLoading(true);
      const response = await fetch(`${API_BASE_URL}/payment_methods_fetch.php`);
      const data = await response.json();
      
      if (data.status === 'success') {
        setPaymentMethods(data.data);
      } else {
        console.error('Failed to fetch payment methods');
      }
    } catch (error) {
      console.error('Error fetching payment methods:', error);
    } finally {
      setLoading(false);
    }
  };

  // Add new payment method
 const addPaymentMethod = async (formDataToSend) => {
  formDataToSend.append('action', 'initiate');

  const response = await fetch(`${API_BASE_URL}/admin_add_payment_methods.php`, {
    method: 'POST',
    body: formDataToSend
  });

  const data = await response.json();

  if (data.status === 'success') {
    setPendingId(data.pending_id);
    setCurrentAction('add');
    setShowOtpModal(true);
  } else {
    alert(data.message);
  }
}; // Update payment method
  const updatePaymentMethod = async (formDataToSend) => {
  formDataToSend.append('action', 'initiate');

  const response = await fetch(`${API_BASE_URL}/admin_change_payment_methods.php`, {
    method: 'POST',
    body: formDataToSend
  });

  const data = await response.json();

  if (data.status === 'success') {
    setPendingId(data.pending_id);
    setCurrentAction('update');   // important
    setShowOtpModal(true);        // open OTP modal
  } else {
    alert(data.message);
  }
};
const verifyOtp = async () => {
  const formDataToSend = new FormData();
  formDataToSend.append('action', 'verify_otp');
  formDataToSend.append('pending_id', pendingId);
  formDataToSend.append('otp', otp);

  const endpoint = currentAction === 'add'
    ? 'admin_add_payment_methods.php'
    : 'admin_change_payment_methods.php';

  const response = await fetch(`${API_BASE_URL}/${endpoint}`, {
    method: 'POST',
    body: formDataToSend
  });

  const data = await response.json();

  if (data.status === 'success') {
    alert(data.message);
    setShowOtpModal(false);
    setOtp('');
    setPendingId(null);
    fetchPaymentMethods();
    closeModal();
  } else {
    alert(data.message);
  }
};
  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    const formDataToSend = new FormData();
    formDataToSend.append('wallet_name', formData.wallet_name);
    formDataToSend.append('wallet_address', formData.wallet_address);
    formDataToSend.append('payment_type', formData.payment_type);
    formDataToSend.append('status', formData.status);
    
    // Append bank fields
    formDataToSend.append('bank_account_holder', formData.bank_account_holder || '');
    formDataToSend.append('bank_payment_method', formData.bank_payment_method || '');
    formDataToSend.append('bank_iban', formData.bank_iban || '');
    formDataToSend.append('bank_swift', formData.bank_swift || '');
    formDataToSend.append('bank_name', formData.bank_name || '');
    formDataToSend.append('bank_address', formData.bank_address || '');
    formDataToSend.append('bank_country', formData.bank_country || '');
    formDataToSend.append('account_currency', formData.account_currency || '');
    
    if (formData.qr_upload) {
      formDataToSend.append('qr_upload', formData.qr_upload);
    }
    
    if (editingMethod) {
      formDataToSend.append('id', editingMethod.id);
      await updatePaymentMethod(formDataToSend);
    } else {
      await addPaymentMethod(formDataToSend);
    }
  };

  // Handle input changes
  const handleInputChange = (e) => {
    const { name, value, files } = e.target;
    
    if (name === 'qr_upload') {
      setFormData(prev => ({
        ...prev,
        [name]: files[0]
      }));
    } else {
      setFormData(prev => ({
        ...prev,
        [name]: value
      }));
    }
  };

  // Reset form
  const resetForm = () => {
    setFormData({
      wallet_name: '',
      wallet_address: '',
      payment_type: 'inr',
      status: 'active',
      qr_upload: null,
      bank_account_holder: '',
      bank_payment_method: '',
      bank_iban: '',
      bank_swift: '',
      bank_name: '',
      bank_address: '',
      bank_country: '',
      account_currency: ''
    });
  };

  // Open add modal
  const openAddModal = () => {
    resetForm();
    setEditingMethod(null);
    setShowModal(true);
  };

  // Open edit modal
  const openEditModal = (method) => {
    setFormData({
      wallet_name: method.wallet_name || '',
      wallet_address: method.wallet_address || '',
      payment_type: method.payment_type || 'Crypto Wallet',
      status: method.status || 'active',
      qr_upload: null,
      bank_account_holder: method.bank_account_holder || '',
      bank_payment_method: method.bank_payment_method || '',
      bank_iban: method.bank_iban || '',
      bank_swift: method.bank_swift || '',
      bank_name: method.bank_name || '',
      bank_address: method.bank_address || '',
      bank_country: method.bank_country || '',
      account_currency: method.account_currency || ''
    });
    setEditingMethod(method);
    setShowModal(true);
  };

  // Open view modal (for viewing details)
  const openViewModal = (method) => {
    setViewingMethod(method);
    setShowViewModal(true);
  };

  // Close view modal
  const closeViewModal = () => {
    setShowViewModal(false);
    setViewingMethod(null);
  };

  // Close modal
  const closeModal = () => {
    setShowModal(false);
    setEditingMethod(null);
    resetForm();
  };

  // Format date
  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  useEffect(() => {
    fetchPaymentMethods();
  }, []);

  return (
    <div className="payment-methods-container">
      <div className="payment-methods-header">
        <h1>Payment Methods</h1>
        <button className="add-btn" onClick={openAddModal}>
          <i className="fas fa-plus"></i> Add Payment Method
        </button>
      </div>

      {loading ? (
        <div className="loading">Loading payment methods...</div>
      ) : (
        <div className="payment-methods-table-container">
          <table className="payment-methods-table">
            <thead>
              <tr>
                <th>ID</th>
                <th>Wallet Name</th>
                <th>Wallet / Bank Info</th>
                <th>Payment Type</th>
                <th>Status</th>
                <th>QR Code</th>
                <th>Created At</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {paymentMethods.length > 0 ? (
                paymentMethods.map((method) => (
                  <tr key={method.id}>
                    <td>{method.id}</td>
                    <td>{method.wallet_name}</td>
                    <td className="wallet-address">
                      {method.payment_type === 'bank' ? (
                        <div className="bank-info">
                          <div className="bank-holder">{method.bank_account_holder}</div>
                          <div className="bank-name">{method.bank_name}</div>
                          <div className="bank-iban">{method.bank_iban}</div>
                        </div>
                      ) : (
                        method.wallet_address
                      )}
                    </td>
                    <td>{method.payment_type}</td>
                    <td>
                      <span className={`status ${method.status}`}>
                        {method.status}
                      </span>
                    </td>
                    <td>
                      {method.qr_upload ? (
                        <img 
                          src={`${IMAGE_BASE_URL}/${method.qr_upload}`} 
                          alt="QR Code" 
                          className="qr-image"
                          onError={(e) => {
                            e.target.style.display = 'none';
                          }}
                        />
                      ) : (
                        <span className="no-qr">No QR</span>
                      )}
                    </td>
                    <td>{formatDate(method.created_at)}</td>
                    <td>
                      <div className="action-buttons">
                        <button 
                          className="edit-btn"
                          onClick={() => openEditModal(method)}
                          title="Edit Payment Method"
                        >
                          <i className="fas fa-edit"></i>
                          <span>Edit</span>
                        </button>
                        <button 
                          className="view-btn"
                          onClick={() => openViewModal(method)}
                          title="View Details"
                        >
                          <i className="fas fa-eye"></i>
                          <span>View</span>
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="8" className="no-data">No payment methods found</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}

      {/* Modal */}
      {showModal && (
        <div className="modal-overlay">
          <div className="modal">
            <div className="modal-header">
              <h2>{editingMethod ? 'Edit Payment Method' : 'Add Payment Method'}</h2>
              <button className="close-btn" onClick={closeModal}>
                <i className="fas fa-times"></i>
              </button>
            </div>
            
            <form onSubmit={handleSubmit} className="payment-form">
              <div className="form-group">
                <label htmlFor="wallet_name">Wallet Name</label>
                <input
                  type="text"
                  id="wallet_name"
                  name="wallet_name"
                  value={formData.wallet_name}
                  onChange={handleInputChange}
                  placeholder="e.g., USDT BEP20"
                />
              </div>

              <div className="form-group">
                <label htmlFor="payment_type">Payment Type</label>
              <select
  id="payment_type"
  name="payment_type"
  value={formData.payment_type}
  onChange={handleInputChange}
>
  <option value="Crypto Wallet">Crypto Wallet</option>
  <option value="bank">Bank</option>
  <option value="inr">INR (UPI / Local Bank)</option>
</select>
              </div>
{formData.payment_type === 'inr' && (
  <>
    <div className="form-group">
      <label htmlFor="wallet_address">UPI ID / Payment Address</label>
      <input
        type="text"
        id="wallet_address"
        name="wallet_address"
        value={formData.wallet_address}
        onChange={handleInputChange}
        placeholder="e.g., yourupi@okaxis"
      />
    </div>
  </>
)}
              {/* Crypto Wallet fields - only show when payment_type is Crypto Wallet */}
              {formData.payment_type === 'Crypto Wallet' && (
                <>
                  <div className="form-group">
                    <label htmlFor="wallet_address">Wallet Address</label>
                    <input
                      type="text"
                      id="wallet_address"
                      name="wallet_address"
                      value={formData.wallet_address}
                      onChange={handleInputChange}
                      placeholder="e.g., 0x678c3c9cdaa9dff6f4e6b0a874d95ecd4b80d9f1"
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="qr_upload">QR Code Image</label>
                    <input
                      type="file"
                      id="qr_upload"
                      name="qr_upload"
                      onChange={handleInputChange}
                      accept="image/*"
                    />
                  </div>
                </>
              )}

              {/* Bank fields - only show when payment_type is bank */}
              {formData.payment_type === 'bank' && (
                <>
                  <div className="form-group">
                    <label htmlFor="bank_account_holder">Bank Account Holder</label>
                    <input
                      type="text"
                      id="bank_account_holder"
                      name="bank_account_holder"
                      value={formData.bank_account_holder}
                      onChange={handleInputChange}
                      placeholder="e.g., WINISTO GLOBAL LLP"
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="bank_payment_method">Bank Payment Method</label>
                    <input
                      type="text"
                      id="bank_payment_method"
                      name="bank_payment_method"
                      value={formData.bank_payment_method}
                      onChange={handleInputChange}
                      placeholder="e.g., SWIFT (International wire)"
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="bank_iban">Bank IBAN</label>
                    <input
                      type="text"
                      id="bank_iban"
                      name="bank_iban"
                      value={formData.bank_iban}
                      onChange={handleInputChange}
                      placeholder="e.g., GB07TCCL04140457635323"
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="bank_swift">Bank SWIFT</label>
                    <input
                      type="text"
                      id="bank_swift"
                      name="bank_swift"
                      value={formData.bank_swift}
                      onChange={handleInputChange}
                      placeholder="e.g., TCCLGB3L"
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="bank_name">Bank Name</label>
                    <input
                      type="text"
                      id="bank_name"
                      name="bank_name"
                      value={formData.bank_name}
                      onChange={handleInputChange}
                      placeholder="e.g., The Currency Cloud Limited"
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="bank_address">Bank Address</label>
                    <input
                      type="text"
                      id="bank_address"
                      name="bank_address"
                      value={formData.bank_address}
                      onChange={handleInputChange}
                      placeholder="e.g., 12 Steward Street, London"
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="bank_country">Bank Country</label>
                    <input
                      type="text"
                      id="bank_country"
                      name="bank_country"
                      value={formData.bank_country}
                      onChange={handleInputChange}
                      placeholder="e.g., United Kingdom"
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="account_currency">Account Currency</label>
                    <input
                      type="text"
                      id="account_currency"
                      name="account_currency"
                      value={formData.account_currency}
                      onChange={handleInputChange}
                      placeholder="e.g., GBP"
                    />
                  </div>
                </>
              )}

              <div className="form-group">
                <label htmlFor="status">Status</label>
                <select
                  id="status"
                  name="status"
                  value={formData.status}
                  onChange={handleInputChange}
                >
                  <option value="active">Active</option>
                  <option value="inactive">Inactive</option>
                </select>
              </div>

              <div className="form-actions">
                <button type="button" className="cancel-btn" onClick={closeModal}>
                  Cancel
                </button>
                <button type="submit" className="submit-btn">
                  {editingMethod ? 'Update' : 'Add'} Payment Method
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* View Modal */}
      {showViewModal && viewingMethod && (
        <div className="modal-overlay" onClick={closeViewModal}>
          <div className="modal-content view-modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h2>Payment Method Details</h2>
              <button className="close-btn" onClick={closeViewModal}>
                <i className="fas fa-times"></i>
              </button>
            </div>
            
            <div className="view-modal-body">
              <div className="view-details-grid">
                <div className="view-detail-item">
                  <label>ID:</label>
                  <span>{viewingMethod.id}</span>
                </div>
                
                <div className="view-detail-item">
                  <label>Wallet Name:</label>
                  <span>{viewingMethod.wallet_name}</span>
                </div>
                
                <div className="view-detail-item">
                  <label>Wallet Address:</label>
                  <span className="wallet-address-view">{viewingMethod.wallet_address}</span>
                </div>
                
                <div className="view-detail-item">
                  <label>Payment Type:</label>
                  <span>{viewingMethod.payment_type}</span>
                </div>
                
                <div className="view-detail-item">
                  <label>Status:</label>
                  <span className={`status ${viewingMethod.status}`}>
                    {viewingMethod.status}
                  </span>
                </div>
                
                {/* Bank details in view modal */}
                {viewingMethod.bank_account_holder && (
                  <>
                    <div className="view-detail-item">
                      <label>Bank Account Holder:</label>
                      <span>{viewingMethod.bank_account_holder}</span>
                    </div>
                    <div className="view-detail-item">
                      <label>Bank Name:</label>
                      <span>{viewingMethod.bank_name}</span>
                    </div>
                    <div className="view-detail-item">
                      <label>IBAN:</label>
                      <span>{viewingMethod.bank_iban}</span>
                    </div>
                    <div className="view-detail-item">
                      <label>SWIFT:</label>
                      <span>{viewingMethod.bank_swift}</span>
                    </div>
                    <div className="view-detail-item">
                      <label>Bank Country:</label>
                      <span>{viewingMethod.bank_country}</span>
                    </div>
                    <div className="view-detail-item">
                      <label>Account Currency:</label>
                      <span>{viewingMethod.account_currency}</span>
                    </div>
                    <div className="view-detail-item">
                      <label>Bank Address:</label>
                      <span className="wallet-address-view">{viewingMethod.bank_address}</span>
                    </div>
                  </>
                )}
                
                <div className="view-detail-item">
                  <label>Created At:</label>
                  <span>{formatDate(viewingMethod.created_at)}</span>
                </div>
              </div>
              
              {viewingMethod.qr_upload && (
                <div className="view-qr-section">
                  <label>QR Code:</label>
                  <div className="view-qr-container">
                    <img 
                      src={`${IMAGE_BASE_URL}/${viewingMethod.qr_upload}`} 
                      alt="QR Code" 
                      className="view-qr-image"
                    />
                  </div>
                </div>
              )}

              {/* Bank account details */}
              {(viewingMethod.bank_name || viewingMethod.account_number || viewingMethod.account_holder) && (
                <div className="view-bank-section">
                  <h3>Bank Account Details</h3>
                  <div className="view-bank-details">
                    {viewingMethod.bank_name && (
                      <div className="view-detail-item">
                        <label>Bank Name:</label>
                        <span>{viewingMethod.bank_name}</span>
                      </div>
                    )}
                    
                    {viewingMethod.account_number && (
                      <div className="view-detail-item">
                        <label>Account Number:</label>
                        <span>{viewingMethod.account_number}</span>
                      </div>
                    )}
                    
                    {viewingMethod.account_holder && (
                      <div className="view-detail-item">
                        <label>Account Holder:</label>
                        <span>{viewingMethod.account_holder}</span>
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>
            
            <div className="view-modal-footer">
              <button className="close-btn-footer" onClick={closeViewModal}>
                Close
              </button>
            </div>
          </div>
        </div>
      )}
      {/* OTP Modal */}
{showOtpModal && (
  <div className="modal-overlay">
    <div className="modal">
      <div className="modal-header">
        <h2>Verify OTP</h2>
        <button className="close-btn" onClick={() => setShowOtpModal(false)}>
          ×
        </button>
      </div>

      <div style={{ padding: '20px' }}>
        <p>OTP has been sent to admin email.</p>

        <input
          type="text"
          value={otp}
          onChange={(e) => setOtp(e.target.value)}
          placeholder="Enter 6 digit OTP"
          style={{
            width: '100%',
            padding: '10px',
            marginTop: '10px',
            fontSize: '16px'
          }}
        />

        <div style={{ marginTop: '20px', textAlign: 'right' }}>
          <button
            onClick={() => setShowOtpModal(false)}
            style={{ marginRight: '10px' }}
          >
            Cancel
          </button>

          <button onClick={verifyOtp}>
            Verify OTP
          </button>
        </div>
      </div>
    </div>
  </div>
)}
    </div>
  );
};

export default PaymentMethods;
